import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=8ff1dfd2&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=ts&"
export * from "./Statistics.vue?vue&type=script&lang=ts&"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=8ff1dfd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff1dfd2",
  null
  
)

export default component.exports